import Swiper, {EffectFade} from 'swiper';
let mySwiper;

mySwiper = new Swiper('.section-tabs-type-2 .tabs-content', {
    modules: [EffectFade],
    loop: false,
    slidesPerView: 1,
    keyboardControl: false,
    updateOnWindowResize: true,
    grabCursor: false,
    effect: 'fade',
    autoHeight: true,
    allowTouchMove: false,
    fadeEffect: {
        crossFade: true
    },
});

$(window).resize(function(){
    mySwiper.updateAutoHeight(300);
});

$('.section-tabs-type-2 .item-tab').on('click', function (e) {
    if ($(this).hasClass('-active')) return;
    let this_numb = $(this).data('tab');
    $(this).closest('.section-tabs-type-2').find('.item-tab').removeClass('-active');
    $(this).addClass('-active');
    mySwiper.slideTo(this_numb);
});

$('.section-tabs-type-2 .logos-box.-popup .logo-popup-opener').on("click", function (e) {
    e.preventDefault();
    let image_src = $(this).find('img').attr('src');
    let image_name = $(this).data('name');
    let section = $(this).closest('.section-tabs-type-2');

    section.find('.logo-popup-box .image-container').html('<img src="'+image_src+'" alt="'+image_name+'">');
    section.find('.logo-popup-box .selected-logo input').val(image_name);
    $("body").addClass("overflow-hidden");
    section.find('.logo-popup-box').addClass("-open");
});

$(".logo-popup-box .close-button, .logo-popup-box .overlay-popup").on("click", function (e) {
    e.preventDefault();
    $(".logo-popup-box").removeClass("-open");
    $("body").removeClass("overflow-hidden");
    $(".logo-popup-opener .wrapper").animate({
        scrollTop: 0
    }, 0);
});